// src/pages/LoginPage.js
import React, { useContext, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Login from "../Login";
import { UserContext } from "../App";
import SEO from "../components/SEO";

export default function LoginPage() {
  const { user, setUser } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();

  const nextPath =
    new URLSearchParams(location.search).get("next") || "/";

  // Ako je već ulogovan, nema smisla da ostaje na /login
  useEffect(() => {
    if (user) navigate(nextPath, { replace: true });
  }, [user, nextPath, navigate]);

  const safeNext =
    nextPath.startsWith("/") ? nextPath : "/";

  return (
    <>
      <SEO
        title="Login | Modular Objects"
        description="Log in to access project documentation and downloads."
        image="https://modularobjects.com/logo.png"
        url={`https://modularobjects.com/login?next=${encodeURIComponent(safeNext)}`}
      />

      <div className="p-4">
        <section className="text-center py-16 bg-background-light dark:bg-background-dark rounded shadow-md border border-gray-100 dark:border-gray-800">
          <h1 className="text-3xl font-bold text-primary-light dark:text-primary-dark mb-3">
            Log in
          </h1>
          <p className="text-text-light dark:text-text-dark max-w-xl mx-auto">
            Log in to access documentation (DXF/BOM/spec), downloads and project files.
          </p>

          <div className="mt-6 flex items-center justify-center gap-3 flex-wrap">
            {/* Ovo otvara tvoj modal */}
            <Login user={user} setUser={setUser} customClass="btn-primary" />

            <Link
              to={safeNext}
              className="bg-primary-light/10 dark:bg-primary-dark/20 text-text-light dark:text-text-dark px-6 py-2 rounded border border-gray-200 dark:border-gray-800 hover:opacity-90 inline-block"
            >
              Back
            </Link>
          </div>

          <p className="mt-6 text-xs text-text-light/60 dark:text-text-dark/60">
            After login you will be redirected to: <span className="font-mono">{safeNext}</span>
          </p>
        </section>
      </div>
    </>
  );
}
